module.exports = __webpack_public_path__ + "static/begum-dcd46576244c11d0f348b6730331f82c.jpg";